import { render, staticRenderFns } from "./TestingSuite.vue?vue&type=template&id=630e7ce7"
import script from "./TestingSuite.vue?vue&type=script&lang=js"
export * from "./TestingSuite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports